export const titles = {
  '/panel/orders/create': 'Create new order               | Exodo Panel ',
  '/panel/orders/read/page': 'Orders list               | Exodo Panel ',
  'panel/orders/export': 'Export orders               | Exodo Panel ',
  '/panel/lms/adsRules': 'Ads Rules                  | Affland.id ',
  '/panel/lms/leads': 'Leads Live                  | Affland.id ',
  '/panel/lms/orders': 'Orders                       | Exodo Panel ',
  '/panel/lms/ordersAdmin': 'Admin Dashboard              | Exodo Panel ',
  '/panel/lms/ordersAgent': 'Agent Dashboard              | Exodo Panel ',
  '/panel/lms/ordersAgent2': 'Agent Dashboard 2            | Exodo Panel ',
  '/panel/lms/ordersTeamLeader': 'Team Leader Dashboard        | Exodo Panel ',
  '/panel/lms/ordersValidation': 'Validation Dashboard         | Exodo Panel ',
  '/panel/lms/products': 'Products Management          | Exodo Panel ',
  '/panel/lms/products/add': 'Add Product               | Exodo Panel ',
  '/panel/lms/products/details': 'Product Details           | Affland.id ',
  '/panel/lms/products/list': 'Payout Partner            | Affland.id ',
  '/panel/lms/leads/postbackList': 'Postback List             | Affland.id ',
  '/panel/lms/products/offers': 'Product Offers            | Affland.id ',
  '/panel/lms/products/payout': 'Payout Admin - All Payouts      | Affland.id ',
  '/panel/lms/utils/classifiers': 'Classifiers Management          | Affland.id ',
  '/panel/lms/products/statistics': 'Product Statistics       | Exodo Panel ',
  '/panel/lms/users': 'Users Management          | Exodo Panel ',
  '/panel/lms/users/edit': 'Edit User                 | Exodo Panel ',
  '/panel/lms/users/profile': 'User Profile              | Exodo Panel ',
  '/panel/lms/utils': 'Utilities                 | Exodo Panel ',
  '/panel/lms/utils/advertiser-integrations': 'Advertiser integrations | Exodo Panel ',
  '/panel/lms/products/advertiser': 'Advertiser products     | Exodo Panel ',
  '/panel/lms/utils/exchangeRate': 'Exchange Rate             | Exodo Panel ',
  '/panel/lms/utils/my-exports': 'My exports                | Exodo Panel '
};
